import * as React from 'react';

import { createIcon } from '../Icon';
export const MoonIcon = createIcon(
  <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />,
  'MoonIcon'
);
